const IOStore = {
  data: {
    output: "",
    err: ""
  },
  methods: {
    output(out = null) {
      if (out === null) return IOStore.data.output;
      IOStore.data.output = out;
    },
    error(err = null) {
      if (err === null) return IOStore.data.err;
      IOStore.data.err = err;
    }
  }
};

export default IOStore;
